import React, { Component } from 'react';

import styles from '../styles/AspectRatio.module.css';

/**
 * Passes the scaling factor to all child components.
 */
export const ScaleContext = React.createContext(1.0);

interface Props {
  /** Initial height of the component. */
  height: number;

  /** Initial width of the component. */
  width: number;
}

interface State {
  scale: number;
}

// TODO: Base this on parent's dimensions instead of window dimensions.
// See [react-resize-detector](https://www.npmjs.com/package/react-resize-detector).

/**
 * A container that scales its content to fit the page while maintaining
 * aspect ratio. The container will be centered on the page if it cannot
 * fill it fully. Letterboxing can be added by setting the parent's
 * background.
 */
class AspectRatio extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      scale: 1
    };
  }

  /**
   * Scale contents based on window size.
   */
  updateScale = () => {
    const viewport = {
      height: window.innerHeight,
      width: window.innerWidth
    };

    const newScale = Math.min(
      viewport.height / this.props.height,
      viewport.width / this.props.width
    );

    this.setState({ scale: newScale });
  };

  componentDidMount() {
    this.updateScale();
    window.addEventListener('resize', this.updateScale);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateScale);
  }

  render() {
    const style = {
      width: this.props.width,
      height: this.props.height,
      transform: `translate(-50%, -50%) scale(${this.state.scale})`
    };
    return (
      <ScaleContext.Provider value={this.state.scale}>
        <div className={styles.root} style={style}>
          {this.props.children}
        </div>
      </ScaleContext.Provider>
    );
  }
}

export default AspectRatio;
